import React, {memo, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { Tooltip as ReactTooltip } from "react-tooltip";
import Popup from 'reactjs-popup';
import ErrorMessage from '../ErrorMessage';

const FormulationGroup = ({ defaultValue, ingredientGroups, field, fieldState: { error } }) => {
  const { name, value, onChange, ...fieldProps } = field;


  // Set default values from state if the user returns to adjust the information from the checkout page
  if (defaultValue) {
    let stateValues = JSON.parse(defaultValue);
    ingredientGroups.forEach(function (ingredientGroup, ingredientGroupIndex) {
      let stateIngredients = stateValues[ingredientGroup.heading];

      if (stateIngredients !== undefined) {
        let found = [];
        stateIngredients.forEach(function (stateIngredient) {
          ingredientGroup.ingredients.forEach(function (groupIngredient, groupIngredientIndex) {
            if (groupIngredient.ingredientName === stateIngredient[0]) {
              ingredientGroups[ingredientGroupIndex].ingredients[groupIngredientIndex].ingredientRecommendedDosageValue = stateIngredient[1];
              ingredientGroups[ingredientGroupIndex].ingredients[groupIngredientIndex].ingredientRemovedByDefault = "no";
              found.push(stateIngredient[0]);
            }
          });
        });

        stateIngredients.forEach(function (stateIngredient) {
          ingredientGroup.ingredients.forEach(function (groupIngredient, groupIngredientIndex) {
           if(!found.includes(groupIngredient.ingredientName)) {
              ingredientGroups[ingredientGroupIndex].ingredients[groupIngredientIndex].ingredientRemovedByDefault = "yes";
            }
          });
        });
      }
    });
  }

  // On load initial configuration
  useEffect(() => {
    document.querySelectorAll('div[id*="_wrapper"]').forEach((item) => {
      item.classList.remove('removed');
      if (item.dataset.ingredientRemovedByDefault === 'yes') {
        item.classList.add('removed');
      }
    });

    updateFormulation();
  }, []);

  // Initialise the optional ingredient dropdown
  let addOptionalIngredientOptions = [];
  ingredientGroups.forEach((ingredientGroup) => {
    if (ingredientGroup.heading === 'Optional ingredients') {
      ingredientGroup.ingredients.forEach((ingredient) => {
        addOptionalIngredientOptions.push({
          value: `${ingredient.ingredientName}_${ingredient.ingredientRecommendedDosageValue}_${ingredient.ingredientDosageUnits}`,
          label: ingredient.ingredientName + ' (' + ingredient.ingredientRecommendedDosageValue + ' ' + ingredient.ingredientDosageUnits + ')',
        });
      });
    }
  });
  const [selectedOptionalIngredient, setSelectedOptionalIngredient] = useState('');

  const resetIngredient = (ingredientName, delayUpdate = false) => {
    const ingredient = document.getElementById(`${ingredientName}_wrapper`);
    const dosageField = document.getElementById(`${ingredient.dataset.ingredientName}_dosage`);
    dosageField.value = ingredient.dataset.ingredientRecommendedDosageValue;

    ingredient.classList.remove('removed');
    if (ingredient.dataset.ingredientRemovedByDefault === 'yes') {
      ingredient.classList.add('removed');
    }

    if (!delayUpdate) {
      updateFormulation();
    }
  }

  // Update the formulation
  const updateFormulation = () => {
    let finalFormulation = {};

    // Only allow 3 optional ingredients
    const optionalIngredients = document.querySelectorAll('div[data-ingredient-type="optional"]:not(.removed)');
    if (optionalIngredients.length > 3) {
      let count = 0;
      optionalIngredients.forEach((item) => {
        if (count > 3) {
          item.classList.add('removed');
        }
        count++;
      });
    }

    document.querySelectorAll('div[id*="_wrapper"]:not(.removed)').forEach((item) => {
      // Group by ingredient type
      let group = '';
      switch (item.dataset.ingredientType) {
        case 'base':
          group = 'Base ingredients';
          break;
        case 'stimulant':
          group = 'Stimulant ingredients';
          break;
        case 'optional':
        default:
          group = 'Optional ingredients';
          break;
      }

      // Initialise the group if it doesn't exist
      if (!finalFormulation[group] || finalFormulation[group].length === 0) {
        finalFormulation[group] = [];
      }

      // Add the ingredient to the group
      const dosageField = document.getElementById(`${item.dataset.ingredientName}_dosage`);
      finalFormulation[group].push([
        item.dataset.ingredientName,
        (dosageField && dosageField.value !== '')
          ? dosageField.value
          : item.dataset.ingredientRecommendedDosageValue,
        item.dataset.ingredientDosageUnits.replace(' per serve', ''),
      ]);
    });

    // Update the field value
    onChange(JSON.stringify(finalFormulation));
  };

  return (
    <div className="formulation-wrapper">
      <span
        className='reset-all'
        onClick={(e) => {
          document.querySelectorAll('div[id*="_wrapper"]').forEach((ingredient) => {
            resetIngredient(ingredient.dataset.ingredientName, true);
          });

          updateFormulation();
        }}
      >Reset All</span>

      {ingredientGroups.length > 0 && ingredientGroups.map((ingredientGroup) => (

        <div className={'form-cols '+ingredientGroup.className}>
          <div className="row g-2">
            <span className="label">
              <span className="h5">
                {ingredientGroup.heading}
                {ingredientGroup.heading === 'Optional ingredients' && " (add up to three)"}</span>
            </span>

            {ingredientGroup.heading === 'Optional ingredients' &&
              <div className="col-12">
                <div className="field-wrapper">
                  <select
                    id='add_optional_ingredient'
                    value={selectedOptionalIngredient}
                    onChange={(e) => {
                      setSelectedOptionalIngredient(e.target.value);
                      if (e.target.value !== '') {
                        document.getElementById('add_optional_ingredient_button').style.display = 'inline-block';
                      }

                      if (document.querySelectorAll('div[data-ingredient-type="optional"]:not(.removed)').length >= 3) {
                        document.getElementById('add_optional_ingredient_button').style.display = 'none';
                      }
                    }}
                  >
                    <option value=''>-- Select an optional ingredient from the drop-down list --</option>
                    {addOptionalIngredientOptions.map((option) => (
                      <option value={option.value}>{option.label}</option>
                    ))}
                  </select>

                  <span
                    id='add_optional_ingredient_button'
                    style={{display: 'none'}}
                    className='add'
                    onClick={(e) => {
                      document.getElementById(`${selectedOptionalIngredient.split('_')[0]}_wrapper`).classList.remove('removed');
                      updateFormulation();
                      setSelectedOptionalIngredient('');
                      document.getElementById('add_optional_ingredient_button').style.display = 'none';
                    }}
                  >Add</span>
                </div>
              </div>
            }

            {ingredientGroup.ingredients.length > 0 && ingredientGroup.ingredients.map((ingredient) => (
              <div
                className='col-12 col-lg-6'
                data-ingredient-name={ingredient.ingredientName}
                data-ingredient-type={ingredient.ingredientType}
                data-ingredient-recommended-dosage-value={ingredient.ingredientRecommendedDosageValue}
                data-ingredient-removed-by-default={ingredient.ingredientRemovedByDefault}
                data-ingredient-dosage-units={ingredient.ingredientDosageUnits}
                id={`${ingredient.ingredientName}_wrapper`}
                data-ingredient-removed={ingredient.ingredientRemovable}
              >
                <div className="field-wrapper">
                <Popup
                  trigger={<span className="ingredient-info"></span>}
                  position="center center"
                  modal
                >
                  {close => (
                    <div>
                      <span dangerouslySetInnerHTML={{ __html: ingredient.ingredientInclusionExplanation.replace(/\r\n|\r|\n/g, '<br>') }}></span>
                      <div className="text-center mt-3">
                        <a className="btn btn-primary null" onClick={close}>
                          Close
                        </a>
                      </div>
                    </div>
                  )}
                </Popup>
                  <label className='ingredient'>
                    <span className="label">
                      {ingredient.ingredientName}
                    </span>
                  </label>

                  {ingredient.ingredientDosageEditable === 'yes' &&
                    <div className='qty-wrapper'>
                      <span
                        className="qty-label"
                      >
                        <span>0</span>
                        <span>&nbsp;{ingredient.ingredientDosageUnits}</span>
                      </span>

                      <span
                        className="dminus"
                        onClick={(e) => {
                          let steps = [...ingredient.ingredientAllowableDosageValues];
                          let currentStep = steps.indexOf(parseFloat(document.getElementById(`${ingredient.ingredientName}_dosage`).value));
                          if (currentStep > 0) {
                            document.getElementById(`${ingredient.ingredientName}_dosage`).value = steps[currentStep - 1];
                          }
                          updateFormulation();
                        }}
                      ></span>
                      <input
                        name={`${ingredient.ingredientName}_dosage`}
                        id={`${ingredient.ingredientName}_dosage`}
                        className="form-control qty-box"
                        type="number"
                        min={Math.min(...ingredient.ingredientAllowableDosageValues)}
                        max={Math.max(...ingredient.ingredientAllowableDosageValues)}
                        defaultValue={ingredient.ingredientRecommendedDosageValue}
                        data-steps={ingredient.ingredientAllowableDosageValues}
                      />
                      <span
                        className="dplus"
                        onClick={(e) => {
                          let steps = [...ingredient.ingredientAllowableDosageValues];
                          let currentStep = steps.indexOf(parseFloat(document.getElementById(`${ingredient.ingredientName}_dosage`).value));
                          if (currentStep < steps.length - 1) {
                            document.getElementById(`${ingredient.ingredientName}_dosage`).value = steps[currentStep + 1];
                          }
                          updateFormulation();
                        }}
                      ></span>
                      <span
                        className="serve_size"
                      >
                        &nbsp;{ingredient.ingredientDosageUnits.replace(' per serve', '')}
                      </span>
                      {ingredient.ingredientDosageEditable === 'yes' &&
                        <span
                          className='reset'
                          onClick={(e) => {
                            resetIngredient(`${ingredient.ingredientName}`);
                          }}
                        >Reset</span>
                      }
                    </div>
                  }

                  {ingredient.ingredientDosageEditable === 'no' &&
                    <span className='serve-info'>
                      <input
                        name={`${ingredient.ingredientName}_dosage`}
                        id={`${ingredient.ingredientName}_dosage`}
                        className="form-control qty-box"
                        type="hidden"
                        defaultValue={ingredient.ingredientRecommendedDosageValue}
                      />
                      <span>{ingredient.ingredientRecommendedDosageValue}</span>
                      <span>&nbsp;{ingredient.ingredientDosageUnits}</span>
                    </span>
                  }

                  {ingredient.ingredientRemovable === 'yes' &&
                    <span
                      className='remove'
                      onClick={(e) => {
                        resetIngredient(`${ingredient.ingredientName}`);
                        document.getElementById(`${ingredient.ingredientName}_wrapper`).classList.add('removed');
                        updateFormulation();
                        setSelectedOptionalIngredient('');
                      }}
                    ></span>
                  }

                  {ingredient.ingredientRemovable === 'yes' &&
                    <span
                      className='add plus-icon'
                      onClick={(e) => {
                        document.getElementById(`${ingredient.ingredientName}_wrapper`).classList.remove('removed');
                        updateFormulation();
                      }}
                    ></span>
                  }

                  {ingredient.ingredientRemovable === 'no' &&

                    <Popup
                    trigger={<span className="remove not-removable"></span>}
                    position="center center"
                    modal
                    >
                    {close => (
                      <div class="text-center">
                        <span dangerouslySetInnerHTML={{ __html: "This ingredient cannot be removed from your formula." }}></span>
                        <div className="text-center mt-3">
                          <a className="btn btn-primary null" onClick={close}>
                            Close
                          </a>
                        </div>
                      </div>
                    )}
                    </Popup>

                  }
                </div>
              </div>
            ))}
            {error && <ErrorMessage message={error.message}/>}
          </div>
        </div>
      ))}
    </div>
  );
};

FormulationGroup.propTypes = {
  field: PropTypes.shape().isRequired,
  fieldState: PropTypes.shape().isRequired,
};

export default memo(FormulationGroup);
